import { ITeamMemberPermission, ICreateTeamMemberPermissionDTO, IUpdateTeamMemberPermissionDTO } from '../types'

import Paths from '../utils/paths'
import { serverApi } from '../utils/request'

class TeamMemberPermissionService {
  public async fetchById(id: string) {
    try {
      const resp: any = await serverApi.get(Paths.teamMemberPermission.getById.replace(':id', id))
      return resp.data
    } catch (e) {
      throw e.data
    }
  }

  public async fetchByUserId(userId: string) {
    try {
      const resp: any = await serverApi.get(Paths.teamMemberPermission.getByUserId.replace(':userId', userId))
      return resp.data
    } catch (e) {
      throw e.data
    }
  }

  public async create(teamMemberPermission: ICreateTeamMemberPermissionDTO) {
    try {
      const resp = await serverApi.post<ITeamMemberPermission>(Paths.teamMemberPermission.create, teamMemberPermission)
      return resp.data
    } catch (e) {
      throw e.data
    }
  }

  public async update(teamMemberPermission: IUpdateTeamMemberPermissionDTO) {
    try {
      const resp = await serverApi.put(Paths.teamMemberPermission.update, teamMemberPermission)
      return resp.data
    } catch (e) {
      throw e.data
    }
  }
}

const teamMemberPermissionService = new TeamMemberPermissionService()
export { teamMemberPermissionService }



// WEBPACK FOOTER //
// ./src/services/TeamMemberPermission.ts